import UnderConstruction from "../common/UnderConstruction";

export default function InventoryAlert() {
  return <UnderConstruction title="Low Stock Alert" />;
}
